var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMegaphone = function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552 32c-13.3 0-24 10.7-24 24v5.7L48 192.6V184c0-13.3-10.7-24-24-24S0 170.7 0 184v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-8.6l117.6 32.1c-3.6 10.2-5.6 21.1-5.6 32.5 0 53 43 96 96 96 46.9 0 86-33.6 94.3-78.1L528 450.3v5.7c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm-24 368.6L48 269.7v-27.4l480-130.9v289.2zM208 384c0-7.1 1.5-13.8 4.3-19.8l91.5 24.9c-2.6 24.1-23 42.8-47.7 42.8-26.5 0-48-21.5-48-48z"
  })));
};
export default SvgMegaphone;